import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import api       from "../api";
import { track } from "../utils/analytics";          
import "../styles/MatchingFlow.css";

function BusinessPlan() {
  const navigate  = useNavigate();
  const { user_id } = useParams();

  const [selectedPlan, setSelectedPlan] = useState("trial");

  /* ───────── analytics: page view ───────── */
  useEffect(() => {
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Business Plans",
    });
  }, []);

  /* ───────── handlers ───────── */

  const handlePlanChange = (e) => {
    setSelectedPlan(e.target.value);

    track("plan_change", {
      account_type : "business",
      new_plan_id  : e.target.value,
      location     : "business_plans",
    });
  };

  const handleCheckout = async () => {
    track("checkout_start", {
      account_type : "business",
      plan_id      : selectedPlan,
    });

    try {
      const { data } = await api.post(
        "/stripe_session",
        { plan: selectedPlan },
        {
          params: { user_id, plan: selectedPlan, account_type: "business" },
          withCredentials: true,
        }
      );

      if (data.status === "success" && data.checkoutUrl) {
        track("checkout_redirect", {
          account_type: "business",
          plan_id     : selectedPlan,
          checkout_url: data.checkoutUrl,
        });
        window.location.href = data.checkoutUrl;
      } else {
        track("checkout_error", {
          account_type: "business",
          plan_id     : selectedPlan,
          message     : data.message || "no_checkout_url",
        });
        console.error("Failed to create a Stripe checkout session.");
      }
    } catch (error) {
      track("checkout_error", {
        account_type: "business",
        plan_id     : selectedPlan,
        message     : error.message,
      });
      console.error("Error creating Stripe session:", error);
    }
  };

  const handleCancel = () => {
    track("navigation_click", {
      location   : "business_plans",
      nav_item   : "Cancel",
      destination: "/signin",
    });
    navigate("/signin");
  };

  /* ───────── render ───────── */
  return (
    <div className="matching-flow-container">
      <header className="logo">
        <a
          href="/"
          onClick={() =>
            track("navigation_click", {
              location   : "business_plans",
              nav_item   : "Logo",
              destination: "/",
            })
          }
        >
          BestDay2Marry
        </a>
      </header>

      <main>
        <h1>Monitor a Venue&apos;s Weather</h1>
        <p>Select your subscription plan to get started:</p>

        <form>
          <fieldset>
            <legend className="visually-hidden">Subscription Plans</legend>

            {[
              { id: "trial",    label: "Trial (Free)",                details: "1 week access, 1 location, 1 date." },
              { id: "standard", label: "Standard ($500 monthly)",     details: "1 location, 1 date." },
              { id: "premium",  label: "Premium ($700 monthly)",      details: "1 location, 1 date, extreme weather data." },
            ].map((p) => (
              <div className="plan-option" key={p.id}>
                <label>
                  <input
                    type="radio"
                    name="plan"
                    value={p.id}
                    checked={selectedPlan === p.id}
                    onChange={handlePlanChange}
                  />
                  <span className="plan-title">{p.label}</span>
                </label>
                <p className="plan-details">{p.details}</p>
              </div>
            ))}
          </fieldset>

          <button type="button" className="big-button" onClick={handleCheckout}>
            Proceed to Payment
          </button>

          <button type="button" className="small-button" onClick={handleCancel}>
            Cancel
          </button>
        </form>
      </main>
    </div>
  );
}

export default BusinessPlan;